import {
  VuexModule,
  Module,
  getModule,
  Mutation,
  Action,
} from "vuex-module-decorators";
import store from "@/store";
import { Config } from "@/config";
import { AuthService } from "@/services/auth.service";
import { DialogsModule } from "./dialogs.module";

/**
 * Test module is defined to perform multiple actions
 * in order to easily test something
 *
 * Test module is not included in global scope in production
 *
 * All getters, mutations and actions must always consider the
 * Config.isProduction, if its true then module must do nothing
 */
@Module({ dynamic: true, store, name: "test" })
export class TestModuleVuex extends VuexModule {
  /**
   * Authentication view
   *
   * In production will always be false
   */
  private edsCheckDisabled = false;
  get getCheckEdsDisabled() {
    return !Config.isProduction && this.edsCheckDisabled;
  }

  @Mutation
  public setEdsCheckDisabled(value: boolean): void {
    this.edsCheckDisabled = value;
  }

  @Action
  public refreshToken() {
    AuthService.refreshToken();
  }

  @Action
  public setEmailConfirmationDialog(value: boolean) {
    DialogsModule.setEmailConfirmationDialog({
      show: value,
      isSent: false,
    });
  }
}

export const TestModule = getModule(TestModuleVuex);

if (!Config.isProduction) {
  window.test = TestModule;
}
